import { mergeStyles } from '@fluentui/react';

export const paginatorStyleClassName = mergeStyles({
  display: 'flex',
  '& .page-size-selector': {
    display: 'flex',
    '& .page-size-selector-dropdown': {
      marginLeft: 8,
    },
  },
  '& .page-index-selector': {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 12,
    '& .page-index-selector-dropdown': {
      marginRight: 8,
    },
    '& .page-change-icon': {
      marginLeft: 8,
      marginRight: 8,
    },
  },
});
